import React, { useState, useEffect } from 'react';
import { Row, Col, Card, Statistic, Progress, Table, message, Button } from 'antd';
import { UserOutlined, CheckCircleOutlined, TrophyOutlined, TeamOutlined, ReloadOutlined } from '@ant-design/icons';
import { getStatistics } from '../../api/admin';

const AdminDashboard = () => {
  const [loading, setLoading] = useState(false);
  const [statistics, setStatistics] = useState({
    total_users: 0,
    completed_users: 0,
    completion_rate: 0,
    avg_avg_score: 0,
    department_stats: [],
    weak_item_stats: []
  });

  useEffect(() => {
    loadStatistics();
    // 每30秒自动刷新
    const interval = setInterval(() => {
      loadStatistics();
    }, 30000);
    
    return () => clearInterval(interval);
  }, []);

  const loadStatistics = async () => {
    try {
      setLoading(true);
      const response = await getStatistics();
      if (response.code === 200) {
        setStatistics(response.data);
      }
    } catch (error) {
      message.error('加载统计数据失败');
    } finally {
      setLoading(false);
    }
  };

  const departmentColumns = [
    {
      title: '部门',
      dataIndex: 'department',
      key: 'department',
    },
    {
      title: '总人数',
      dataIndex: 'total',
      key: 'total',
    },
    {
      title: '已完成',
      dataIndex: 'completed',
      key: 'completed',
    },
    {
      title: '完成率',
      dataIndex: 'rate',
      key: 'rate',
      render: (rate) => (
        <Progress 
          percent={rate} 
          size="small" 
          status={rate >= 80 ? 'success' : 'normal'}
        />
      ),
    },
  ];

  const weaknessColumns = [
    {
      title: '准则序号',
      dataIndex: 'weak_item',
      key: 'weak_item',
      width: 120,
    },
    {
      title: '选择人数',
      dataIndex: 'count',
      key: 'count',
      sorter: (a, b) => a.count - b.count,
    },
    {
      title: '占比',
      key: 'percentage',
      render: (_, record) => {
        const total = statistics.weak_item_stats?.reduce((sum, item) => sum + item.count, 0) || 1;
        return `${Math.round((record.count / total) * 100)}%`;
      }
    },
  ];

  return (
    <div>
      <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: '24px' }}>
        <h2 style={{ margin: 0 }}>首页概览</h2>
        <Button 
          icon={<ReloadOutlined />} 
          onClick={loadStatistics}
          loading={loading}
        >
          刷新数据
        </Button>
      </div>
      
      {/* 核心指标卡片 */}
      <Row gutter={[16, 16]} style={{ marginBottom: '24px' }}>
        <Col xs={24} sm={12} lg={6}>
          <Card>
            <Statistic
              title="总用户数"
              value={statistics.total_users}
              prefix={<UserOutlined />}
              valueStyle={{ color: '#1890ff' }}
            />
          </Card>
        </Col>
        <Col xs={24} sm={12} lg={6}>
          <Card>
            <Statistic
              title="已完成人数"
              value={statistics.completed_users}
              prefix={<CheckCircleOutlined />}
              valueStyle={{ color: '#52c41a' }}
            />
          </Card>
        </Col>
        <Col xs={24} sm={12} lg={6}>
          <Card>
            <Statistic
              title="完成率"
              value={statistics.completion_rate}
              suffix="%"
              prefix={<TeamOutlined />}
              valueStyle={{ color: '#722ed1' }}
            />
          </Card>
        </Col>
        <Col xs={24} sm={12} lg={6}>
          <Card>
            <Statistic
              title="平均分"
              value={statistics.avg_avg_score}
              precision={2}
              prefix={<TrophyOutlined />}
              valueStyle={{ color: '#faad14' }}
            />
          </Card>
        </Col>
      </Row>

      {/* 部门统计和薄弱项统计 */}
      <Row gutter={[16, 16]}>
        <Col xs={24} lg={12}>
          <Card 
            title="部门完成情况" 
            loading={loading}
            extra={<a href="/admin/statistics">查看详情</a>}
          >
            <Table
              columns={departmentColumns}
              dataSource={statistics.department_stats}
              rowKey="department"
              pagination={false}
              size="small"
            />
          </Card>
        </Col>
        <Col xs={24} lg={12}>
          <Card 
            title="薄弱项分布" 
            loading={loading}
            extra={<a href="/admin/statistics">查看详情</a>}
          >
            <Table
              columns={weaknessColumns}
              dataSource={statistics.weak_item_stats}
              rowKey="weak_item"
              pagination={false}
              size="small"
            />
          </Card>
        </Col>
      </Row>
    </div>
  );
};

export default AdminDashboard;
